import React from 'react';
import { fromAny as parse } from 'any-date-parser';
import './AppToolTime.css';

class AppToolTime extends React.Component {

  constructor(props){
    super(props);
    const currentTimestamp = Math.floor(Date.now() / 1000);
    this.state = {
      parsedDate: null,
      error: null,
      originalTime: String(currentTimestamp),
      showQuickInput: false, // Whether to show the quick input panel
      inputFormat: "", // Description of the detected input format
    }
    this.handleChange = this.handleChange.bind(this);
    this.toggleQuickInput = this.toggleQuickInput.bind(this);
    this.insertCurrentTimestamp = this.insertCurrentTimestamp.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.dateInputRef = React.createRef();
  }

  componentDidMount() {
    this.parseTime(this.state.originalTime);
  }

  parseTime(timeStr) {
    if (!timeStr) {
        this.setState({ parsedDate: null, error: null, inputFormat: "" });
        return;
    }

    try {
        let input = timeStr.trim();
        let format = "";
        
        // Detect input format
        if (/^\d+$/.test(input)) {
            if (input.length > 10) {
                format = "Unix Timestamp (毫秒)";
                input = Number(input); // Already in milliseconds
            } else {
                format = "Unix Timestamp (秒)";
                input = Number(input) * 1000; // Convert seconds to milliseconds
            }
        } else if (/^\d{4}-\d{1,2}-\d{1,2}\s+\d{1,2}:\d{1,2}:\d{1,2}$/.test(input)) {
            format = "YYYY-MM-DD HH:mm:ss 格式";
        } else if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(input)) {
            format = "YYYY-MM-DD 格式";
        } else if (/^\d{4}-\d{1,2}-\d{1,2}T\d{1,2}:\d{1,2}:\d{1,2}(?:\.\d{3})?Z?$/.test(input)) {
            format = "ISO 8601 格式";
        } else if (/^(now|today|tomorrow|yesterday|next|last|\d+\s+(day|days|week|weeks|month|months|year|years))/.test(input.toLowerCase())) {
            format = "自然语言描述";
        } else if (/^\d{13,}$/.test(input)) {
            format = "Unix Timestamp (毫秒)";
        } else {
            format = "未知格式";
        }

        const date = parse(input);

        if (date.invalid || isNaN(date.getTime())) {
            this.setState({ parsedDate: null, error: "无法解析该时间格式或时间值无效", inputFormat: "" });
        } else {
            this.setState({ parsedDate: date, error: null, inputFormat: format });
        }
    } catch (e) {
        this.setState({ parsedDate: null, error: "解析出错: " + e.message, inputFormat: "" });
    }
  }

  handleChange(e){
    const timeStr = e.target.value;
    this.setState({ originalTime: timeStr });
    this.parseTime(timeStr);
    
    // Clear the date input when user types in the textarea
    if (this.dateInputRef.current) {
      this.dateInputRef.current.value = '';
    }
  }

  toggleQuickInput() {
    this.setState(prevState => ({
      showQuickInput: !prevState.showQuickInput
    }));
  }

  insertCurrentTimestamp() {
    const timestamp = Math.floor(Date.now() / 1000);
    const timeStr = String(timestamp);
    this.setState({ originalTime: timeStr });
    this.parseTime(timeStr);
  }

  handleDateChange(e) {
    const timeStr = e.target.value;
    if (timeStr) {
        this.setState({ originalTime: timeStr });
        this.parseTime(timeStr);
    }
  }

  render() {
    const { originalTime, parsedDate, error, showQuickInput, inputFormat } = this.state;
    const showResult = originalTime.length > 0;

    return (
      <div id="tool_time">
        <div id="content_box">
          <div className="quick-input-panel">
            <button 
              className="quick-input-toggle" 
              onClick={this.toggleQuickInput}
            >
              {showQuickInput ? '隐藏快捷输入' : '显示快捷输入'}
            </button>
            
            {showQuickInput && (
              <div className="quick-input-options">
                <div className="quick-input-row">
                  <label>当前时间戳 (秒):</label>
                  <button onClick={this.insertCurrentTimestamp}>插入</button>
                </div>
                <div className="quick-input-row">
                  <label>选择日期时间:</label>
                  <input type="datetime-local" step="1" onChange={this.handleDateChange} ref={this.dateInputRef} />
                </div>
              </div>
            )}
          </div>

          <textarea
              type="text"
              rows="4"
              placeholder="请输入待解析的时间字符串，例如: '2024-01-01 12:00:00', '1756639907'"
              cols="130"
              onChange={this.handleChange}
              value={originalTime}
              className={!showResult ? 'empty-input' : ''}
          ></textarea>
          {showResult && (
            error ? (
              <pre className="error-message">{error}</pre>
            ) : parsedDate && (
              <div className="result-container">
                {inputFormat && (
                  <div className="input-format-info">
                    <strong>输入格式:</strong> {inputFormat}
                  </div>
                )}
                <table className="result-table">
                  <thead>
                    <tr>
                      <th className="result-label">时间格式</th>
                      <th className="result-value">&nbsp;时间值</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="result-label">YYYY-MM-DD HH:mm:ss</td>
                      <td className="result-value">{parsedDate.getFullYear()}-{String(parsedDate.getMonth() + 1).padStart(2, '0')}-{String(parsedDate.getDate()).padStart(2, '0')} {String(parsedDate.getHours()).padStart(2, '0')}:{String(parsedDate.getMinutes()).padStart(2, '0')}:{String(parsedDate.getSeconds()).padStart(2, '0')}</td>
                    </tr>
                    <tr>
                      <td className="result-label">ISO 8601</td>
                      <td className="result-value">{parsedDate.toISOString()}</td>
                    </tr>
                    <tr>
                      <td className="result-label">UTC String</td>
                      <td className="result-value">{parsedDate.toUTCString()}</td>
                    </tr>
                    <tr>
                      <td className="result-label">Local String</td>
                      <td className="result-value">{parsedDate.toString()}</td>
                    </tr>
                    <tr>
                      <td className="result-label">Unix Timestamp (s)</td>
                      <td className="result-value">{Math.floor(parsedDate.getTime() / 1000)}</td>
                    </tr>
                    <tr>
                      <td className="result-label">Unix Timestamp (ms)</td>
                      <td className="result-value">{parsedDate.getTime()}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )
          )}
        </div>
      </div>
    );
  }
}

export default AppToolTime;
